import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone, MapPin, Instagram, Linkedin, Globe } from "lucide-react";
import { ASSETS, SOCIALS } from "../lib/assets";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-evo-black border-t border-white/5 z-10">
    <div className="px-6 md:px-12 lg:px-20 pt-24 pb-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <img src={ASSETS.logo} alt="EVO Global Exhibitions" className="evo-logo h-16 w-auto object-contain mb-8" />
          <p className="font-serif text-3xl md:text-4xl leading-tight text-evo-pearl font-light max-w-md">
            Let's build something <span className="text-evo-gold italic">extraordinary</span> on the show floor.
          </p>
          <Link
            to="/contact"
            data-testid="footer-quote-btn"
            className="mt-8 inline-flex items-center gap-2 border border-evo-gold/60 text-evo-gold hover:bg-evo-gold hover:text-evo-black transition-colors duration-300 px-8 py-4 text-xs uppercase tracking-[0.2em] group"
          >
            Request a Quotation
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="lg:col-span-3 lg:col-start-8">
          <p className="text-xs uppercase tracking-[0.25em] text-evo-gold mb-6">Navigate</p>
          <ul className="space-y-3">
            {[["Home","/"],["Services","/services"],["Staffing","/staffing"],["Portfolio","/experiences"],["About","/about"],["Contact","/contact"]].map(([l,t]) => (
              <li key={t}>
                <Link to={t} className="text-evo-ash hover:text-evo-pearl transition-colors">{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] text-evo-gold mb-6">Contact</p>
          <ul className="space-y-4 text-evo-ash text-sm">
            <li className="flex items-start gap-3"><Mail size={16} className="text-evo-gold mt-0.5 shrink-0" /><span>info@evoexhibitions.com</span></li>
            <li className="flex items-start gap-3"><Mail size={16} className="text-evo-gold mt-0.5 shrink-0" /><span>sales@evoexhibitions.com</span></li>
            <li className="flex items-start gap-3"><Phone size={16} className="text-evo-gold mt-0.5 shrink-0" /><span>+39 347 296 1122</span></li>
          </ul>
          <p className="text-xs uppercase tracking-[0.25em] text-evo-gold mb-6 mt-10">Locations</p>
          <ul className="space-y-4 text-evo-ash text-sm">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-evo-gold mt-0.5 shrink-0" /><span>Italy — Headquarters</span></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="text-evo-gold mt-0.5 shrink-0" /><span>Dubai, UAE — Office</span></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="text-evo-gold mt-0.5 shrink-0" /><span>Saudi Arabia — Regional Operations</span></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-10 border-t border-white/5 flex flex-wrap items-center gap-x-8 gap-y-4">
        <a href={SOCIALS.website} target="_blank" rel="noopener noreferrer" data-testid="footer-website" className="inline-flex items-center gap-2 text-evo-ash hover:text-evo-gold transition-colors text-sm">
          <Globe size={16} className="text-evo-gold" /> {SOCIALS.websiteLabel}
        </a>
        <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 text-evo-ash hover:text-evo-gold transition-colors text-sm">
          <Instagram size={16} className="text-evo-gold" /> {SOCIALS.instagramLabel}
        </a>
        <a href={SOCIALS.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="inline-flex items-center gap-2 text-evo-ash hover:text-evo-gold transition-colors text-sm">
          <Linkedin size={16} className="text-evo-gold" /> {SOCIALS.linkedinLabel}
        </a>
      </div>

      <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-evo-ash/60 tracking-wide">© {new Date().getFullYear()} EVO Global Exhibitions. All rights reserved.</p>
        <p className="text-xs uppercase tracking-[0.25em] text-evo-ash/60">Design · Build · Deliver</p>
      </div>
    </div>
  </footer>
);
